export function ImportMetadata({
  file,
  layers,
  count,
  scope,
}: {
  readonly file: string;
  readonly layers: readonly string[];
  readonly count: number | null;
  readonly scope?: string | undefined;
}) {
  return (
    <dl className="import-metadata">
      <div>
        <dt>File</dt>
        <dd>{file}</dd>
      </div>
      <div>
        <dt>{layers.length > 1 ? 'Layers' : 'Layer'}</dt>
        <dd>{layers.join(', ')}</dd>
      </div>
      <div>
        <dt>Records</dt>
        <dd>{count === null ? 'Not available' : count.toLocaleString()}</dd>
      </div>
      {scope ? (
        <div>
          <dt>Scope</dt>
          <dd>{scope}</dd>
        </div>
      ) : null}
    </dl>
  );
}
